import { SmartLink } from '@/components/SmartLink';
import { useSite } from '@/contexts/SiteContext';
import type { Event_Entry } from '@/types/graphql';
import { cn } from '@/utils/cn';
import { getShowPageLink, getShowProgramStart } from '@/utils/show';
import { formatDate } from '../utils/dateFormat';

interface ShowTile {
    event: Event_Entry;
    className?: string;
}

export default function ShowLadderItem({ event, className }: ShowTile) {
    const startDate = getShowProgramStart(event);
    const { locale } = useSite();

    if (!event.slug) {
        return null;
    }

    return (
        <SmartLink
            href={getShowPageLink(event)}
            className={cn('relative flex', className, 'cursor-pointer', 'overflow-hidden', 'h-14')}
        >
            {/* Overlay for canceled events */}
            {event.status === 'cancelled' && (
                <div className="absolute inset-0 z-10 bg-black opacity-60" />
            )}

            {/* Event Info */}
            <div className={cn('flex w-full flex-row-reverse items-center')}>
                <div
                    className={cn(
                        'h-full w-12 px-4',
                        'flex flex-col items-center justify-center',
                        'text-black',
                        'bg-white/60'
                    )}
                >
                    <div className="break-words font-bold text-2xl">
                        {formatDate.dayShort(startDate, locale)}
                    </div>
                    <div className="font-bold text-sm uppercase">
                        {formatDate.monthShort(startDate, locale)}
                    </div>
                </div>
                <div
                    className={cn(
                        'pl-4',
                        'flex flex-col justify-center',
                        'w-full flex-grow',
                        'break-words font-bold text-lg sm:text-base'
                    )}
                >
                    {event.eventTitle}
                </div>
            </div>
        </SmartLink>
    );
}
